var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.hasRight('53'))?_c('FinancialDashboard'):_vm._e(),(_vm.$store.state.hasRight('200') && !_vm.$store.state.isAdmin())?_c('ShowcaseDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }